/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  RebateProgramcellHead,
  cellHead1,
  ClientHead,
  RebateProgramcellHeadForPopUP,
  popupField,
} from './tableHead';
import PlanSearchCriteria from './planSearchCriteria';
import { getgeneralsystemparameterDetails } from '../../../System/systemParameter/store/actions';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  dispatchContactDetailsPlan,
  getPlansByCgp,
  saveContactData,
  setIsValidContactForm,
  setPlanDataAction,
  setPlanTabData,
  setReduxDataSearchScreen,
} from '../store/actions';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { DOUBLE_CLICK_GRID_MSG } from '../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const PlanForm = (props) => {
  const dispatch = useDispatch();
  const planByCGP = useSelector((state) => {
    return state.sharedState.PlanReducer.plansByCgp;
  });
  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const reduxDataSearchScreen = useSelector(
    (state) => state?.sharedState?.PlanReducer?.searchScreenData
  );
  const getPlansByCGPValue = (values) => dispatch(getPlansByCgp(values));
  const [redirect, setRedirect] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(
    reduxDataSearchScreen?.state?.selectPlan || 'P'
  );
  const [fullScreenView, setFullScreenView] = useState(false);
  const [multiPlan, setMultiPlan] = useState({
    open: false,
    rowData: null,
    tableData: [],
  });
  const [planTblData, setPlanTblData] = React.useState([]);
  const [popupTblData, setPopupTblData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [popupSelected, setPopupSelected] = React.useState();

  const planRebateClientSearchData = useSelector(
    (state) => state.sharedState.PlanReducer.planRebateClientSearchData
  );

  const getClients = () => {
    axios.get(serviceEndPoint.CLIENT_FROM_CGP).then((resp) => {
      const data = resp.data.clientList;
      const numbers = data?.filter(
        (element) => !isNaN(element.clientId.trim())
      );
      const strings = data?.filter((element) => isNaN(element.clientId.trim()));
      if (data?.length > 0) {
        dispatch(setPlanDataAction([...numbers, ...strings]));
      } else {
        dispatch(setPlanDataAction([]));
      }
    });
  };

  const getRebateProgram = () => {
    axios
      .post(serviceEndPoint.GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE)
      .then((response) => {
        const data = response?.data?.data;

        dispatch(setPlanDataAction(data && data.length > 0 ? data : []));
      });
  };

  const getAllPlans = () => {
    axios.post(serviceEndPoint.GET_ALL_PLANS).then((response) => {
      const data = response?.data?.data;
      const numbers = data
        ?.filter((element) => !isNaN(element.planId.trim()))
        .sort((a, b) => a.planId - b.planId);
      const strings = data
        ?.filter((element) => isNaN(element.planId.trim()))
        .sort((a, b) => a.planId - b.planId);
      let newArr = [],
        list = [...numbers, ...strings];
      for (let i = 0; i < list.length; i++) {
        let currls = newArr.filter((obj) => obj.planId === list[i].planId);
        let addVal = true;
        for (let j = 0; j < currls.length; j++) {
          if (
            list[i].planId == currls[j].planId &&
            list[i].planName == currls[j].planName
          )
            addVal = false;
        }
        if (addVal) newArr.push(list[i]);
      }
      setPlanTblData(newArr);
      dispatch(
        setPlanDataAction(
          data && data.length > 0 ? [...numbers, ...strings] : []
        )
      );
    });
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  useEffect(() => {
    // dispatch(getgeneralsystemparameterDetails());
    if (selectedPlan === 'R') {
      getRebateProgram();
    } else if (selectedPlan === 'C') {
      getClients();
    } else {
      getAllPlans();
    }
  }, [selectedPlan]);

  const closeMultiPlan = (value) => {
    if (value) {
      setMultiPlan({ ...multiPlan, open: value });
    } else {
      setMultiPlan({ open: value, rowData: null, tableData: [] });
    }
  };

  useEffect(() => {
    if (redirect) {
      dispatch(dispatchContactDetailsPlan([]));
      dispatch(saveContactData({}));
      dispatch(setIsValidContactForm(false));
      dispatch(
        setPlanTabData({ disabledSaveCancelBtn: true, tabValue: 'one' })
      );
      redirectURLLink(
        '/createNewPlan',
        'Maintain Plan',
        props.history,
        dispatch
      );
      props.history.push({
        pathname: '/createNewPlan',
        state: { planByCGP },
        isRefresh: true,
      });
    }
  }, [planByCGP]);

  const onCellClickedListener = (rowData) => {
    axios
      .post(serviceEndPoint.GRT_PLANS_BY_CLIENT, rowData)
      .then((response) => {
        if (response.data && response.data) {
          const data =
            response.data &&
            response.data.data &&
            response.data.data.map((v) => ({
              clientId: v.cgpId.clientId,
              planId: v.cgpId.planId,
              groupId: v.cgpId.groupId,
              planName: v.planName,
            }));
          if (response.data.data.length > 1) {
            setMultiPlan({ open: true, rowData, tableData: data });
          } else {
            getPlansByCGPValue(data[0]);

            window.localStorage.setItem(
              'planSearchCriteria',
              JSON.stringify(data[0])
            );
            window.localStorage.setItem('planSearchOrAdd', 'search');
            setRedirect(true);
          }
        }
      });
  };

  const onSelectionPlan = (e, check = false) => {
    if (check) {
      const samePlanId = planRebateClientSearchData?.filter(
        (obj) =>
          obj.planId === e.data.planId && obj.planName === e.data.planName
      );
      if (samePlanId.length > 1) {
        setPopupTblData(samePlanId);
        setOpen(true);
        return;
      }
    }
    getPlansByCGPValue(e.data || popupSelected);
    window.localStorage.setItem(
      'planSearchCriteria',
      JSON.stringify(e.data || popupSelected)
    );
    window.localStorage.setItem('planSearchOrAdd', 'search');
    setRedirect(true);
  };

  const onSelectionChanged = (rowData) => {
    axios
      .post(serviceEndPoint.GET_ALL_PLANS_BY_REBATE_PROGRAM, rowData)
      .then((response) => {
        if (response.data.length > 1) {
          setMultiPlan({ open: true, rowData, tableData: response.data });
        } else {
          const data = response?.data[0];
          getPlansByCGPValue(data);

          window.localStorage.setItem(
            'planSearchCriteria',
            JSON.stringify(data)
          );
          window.localStorage.setItem('planSearchOrAdd', 'search');
          setRedirect(true);
        }
      });
  };

  const onSelectionRebatePopup = (e) => {
    const selectedRow = e.data;
    getPlansByCGPValue(selectedRow);
    window.localStorage.setItem(
      'planSearchCriteria',
      JSON.stringify(selectedRow)
    );
    window.localStorage.setItem('planSearchOrAdd', 'search');
    setRedirect(true);
  };

  const onSelectionClientPopup = (e) => {
    const selectedRow = e.data;
    getPlansByCGPValue(selectedRow);
    window.localStorage.setItem(
      'planSearchCriteria',
      JSON.stringify(selectedRow)
    );
    window.localStorage.setItem('planSearchOrAdd', 'search');
    setRedirect(true);
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // handing by default first row selection function
  const onGridReady = (params) => {
    params.api.forEachNode(
      (node) =>
        node.rowIndex === reduxDataSearchScreen?.currentIndex &&
        node.setSelected(true)
    );
  };
  return (
    <>
      <div className="tabs-container">
        <ModalDialog
          open={multiPlan?.open}
          closeModal={closeMultiPlan}
          grid={
            <Grid
              isModalTable
              gridHeight="270px"
              rowData={multiPlan.tableData}
              defaultCol={{ editable: false }}
              columnDefs={RebateProgramcellHeadForPopUP}
              cellClickedListener={
                selectedPlan === 'R'
                  ? onSelectionRebatePopup
                  : onSelectionClientPopup
              }
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportFile
              data-testid="onEditingStopped"
              fileName="Rebate_client"
              helpMessage={DOUBLE_CLICK_GRID_MSG}
            />
          }
          dialogTitle="Choose a Plan"
          cancelAction={closeMultiPlan}
        />
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1="Maintain" parent2="Plan" />
        {!fullScreenView && (
          <>
            <PlanSearchCriteria
              setSelectedPlan={setSelectedPlan}
              fullScreenView={fullScreenView}
              setFullScreenView={setFullScreenView}
              selectedPlan={selectedPlan}
              generalSystemParameterDetails={generalSystemParameterDetails}
            />
            <div className="devider-line pb-4" />
          </>
        )}
        <Grid
          rowData={
            selectedPlan === 'P' ? planTblData : planRebateClientSearchData
          }
          defaultCol={{ editable: false }}
          gridCall={onGridReady}
          columnDefs={
            selectedPlan === 'R'
              ? RebateProgramcellHead
              : selectedPlan === 'C'
              ? ClientHead
              : cellHead1
          }
          cellClickedListener={(e) => {
            dispatch(
              setReduxDataSearchScreen({
                ...reduxDataSearchScreen,
                currentIndex: e?.rowIndex,
              })
            );
            if (selectedPlan === 'P') {
              onSelectionPlan(e, true);
            } else if (selectedPlan === 'R') {
              onSelectionChanged(e.data);
            } else {
              onCellClickedListener(e.data);
            }
          }}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          exportFile
          helpMessage={DOUBLE_CLICK_GRID_MSG}
          data-testid="onEditingStopped"
          fileName="Plan"
          gridHeight={fullScreenView ? 'auto' : 350}
        />
      </div>

      <CommonModal
        open={open}
        viewAction
        // className="dialog-420"
        viewHeader
        onOk={() => {
          if (popupSelected) onSelectionPlan(popupSelected);
          setPopupSelected();
          setOpen(false);
        }}
        disableOk={!popupSelected}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setOpen(false)}
        modalTitle="Select a Plan"
        childrenComponent={
          <Grid
            rowData={popupTblData}
            defaultCol={{ editable: false }}
            columnDefs={[...popupField, ...cellHead1]}
            cellClickedListener={(e) => onSelectionPlan(e)}
            onSelectionChanged={(e) =>
              setPopupSelected(e.api.getSelectedRows()?.[0])
            }
            navigateToNextCell={navigateToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            helpMessage={DOUBLE_CLICK_GRID_MSG}
            data-testid="onEditingStopped"
            fileName="Plan"
            gridHeight={fullScreenView ? 'auto' : 350}
          />
        }
      />
    </>
  );
};

export default PlanForm;
